import React from "react"

export default function WubotComponent() {
  return (
    <div class = "lex-web-ui-iframe lex-web-ui-iframe--hide"
         id = "lex-web-ui-iframe"></div>
    )
}